module.exports = __webpack_public_path__ + "img/Frame4296.0c3fca42.jpg";